import styled from '@emotion/styled';

export const Container = styled.div`
  .ant-tag {
    margin: 0;
    margin-bottom: 5px;
  }
`;